module.exports = __webpack_public_path__ + "static/media/pingPong.d8c5a1d5.jpg";